export default __webpack_public_path__ + "static/media/stripe-verification.e3395540.svg";